var overlay = document.getElementsByClassName('js-overlay')[0];
var body = document.getElementsByTagName('body')[0];

function show() {
  overlay.classList.add('s-visible');

  // Work around z-index and stacking context issues by modifying elements with this state class
  body.classList.add('s-overlayVisible');
}

function hide(cb) {
  overlay.classList.remove('s-visible');
  body.classList.remove('s-overlayVisible');
}

// Adds callbacks to the click event
function addClickHandler(cb) {
  overlay.addEventListener('click', cb);
}

module.exports = {
  show: show,
  hide: hide,
  addClickHandler: addClickHandler
};